-#due historical reasons - at some places we need to show/hide blocks
-#TODO - rewrite classes to allow functionality only where needed, not everywhere
<template lang="pug">
section.active
  template(v-for="form_block in form_blocks" v-if="form_block.to_display()")
    div(v-if="content(form_block)", :is="content(form_block)", :form_block="form_block" :parent_entity_id="old_rfb.entity_id")
    .form-block(v-else :set="rfb=r_form_block(form_block)")
      .form-block-content
        fb-content(
          :form_block="form_block" :entity_selected="entity_selected"
          :entity_attrs="rfb.entity_attrs" @entity_attrs:input="rfb.entity_attrs=$event;registration.doTouch()"
          :custom_attrs="rfb.custom_attrs" @custom_attrs:input="rfb.custom_attrs=$event;rfb.has_changed=true"
          :member_attrs="rfb.member_attrs" @member_attrs:input="rfb.member_attrs=$event;registration.doTouch()"
        )
</template>
<script>
import FbContent from '../form_block/_content'
import ContentPartParentAddress from './content/_part_parent_address'
export default{
  name: "FormPartContent",
  components: {FbContent,ContentPartParentAddress},
  props: ["form_blocks", "old_rfb", "entity_selected"],
  computed: {
    registration(){ return this.state.current_reg },
  },
  methods: {
    content(form_block){
      return this.$options.components[this.content_name(form_block)]
    },
    content_name(form_block){
      const arr = form_block.style.split("::")
      return "Content"+arr[arr.length-1]
    },
    r_form_block(form_block=this.form_block){
      return this.state.current_reg.find_rblock(form_block, this.old_rfb)
    },
  }
}
</script>